import { useCallback } from 'react';

import { useSeek } from '@/scenarios/legacy-player/hooks/useSeek';

export const useSeekToAir = () => {
    const { seekToTime } = useSeek();

    const seekToAir = useCallback(() => {
        seekToTime(Number.MAX_SAFE_INTEGER);
    }, [seekToTime]);

    return seekToAir;
};
